<div class="container-fluid">
  <div class="styles-body">
    <div class="panel-body content-body-pages">
      <div class="page-header">
        <div class="header-content">
          <div class="header-icon">
            <mat-icon>groups</mat-icon>
          </div>
          <div class="header-text">
            <h1 class="page-title">{{ 'CustomerClub' | translate }}</h1>
            <p class="page-subtitle">{{ 'MemberProfileAndActivityOverview' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="user-dashboard">
        <div class="profile-summary-card">
          <div class="profile-header-section">
            <div class="profile-avatar-section">
              <div class="profile-avatar">
                <div class="avatar-container">
                  <mat-icon class="avatar-icon">person</mat-icon>
                </div>
              </div>
              <div class="user-rank-badge">
                <div class="rank-icon">
                  <mat-icon>workspace_premium</mat-icon>
                </div>
                <div class="rank-content">
                  <div class="rank-title">{{ 'MemberRank' | translate }}</div>
                  <div class="rank-value">{{ getUserRank() }}</div>
                </div>
                <div class="rank-decoration">
                  <div class="sparkle sparkle-1">✨</div>
                  <div class="sparkle sparkle-2">⭐</div>
                  <div class="sparkle sparkle-3">💎</div>
                </div>
              </div>
            </div>
            <div class="profile-details">
              <h3
                class="member-name">{{ (user?.FirstName | onlinetranslate) }} {{ (user?.LastName | onlinetranslate) }}
              </h3>
              <p class="member-id">{{ 'MemberID' | translate }}: {{ user?.UserId }}</p>
              <div class="contact-info">
                <div class="contact-item">
                  <mat-icon>phone</mat-icon>
                  <span>{{ (user?.MobileNumber | onlinetranslate) }}</span>
                </div>
                <div class="contact-item">
                  <mat-icon>credit_card</mat-icon>
                  <span>{{ (user?.NationalCode | onlinetranslate) }}</span>
                </div>
              </div>
            </div>
            <div class="profile-stats">
              <div class="stat-item">
                <div class="stat-number">{{ getTotalPurchaseAmount() | number:'1.0-0' }}
                  <span
                    class="currency">ریال</span>
                </div>
                <div class="stat-label">{{ 'TotalPurchase' | translate }}</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">{{ orders?.length || 0 }}</div>
                <div class="stat-label">{{ 'TotalOrders' | translate }}</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">{{ userAttributes?.length || 0 }}</div>
                <div class="stat-label">{{ 'Attributes' | translate }}</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">{{ userExtraAttributes?.length || 0 }}</div>
                <div class="stat-label">{{ 'ExtraFeatures' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="quick-info-grid">
          <div class="info-card personal-info">
            <div class="card-header">
              <mat-icon>person_outline</mat-icon>
              <h4>{{ 'PersonalInformation' | translate }}</h4>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="label">{{ 'BirthDate' | translate }}:</span>
                <span class="value">{{ (user?.BirthDate | time: 'YYYY/MM/DD') }}</span>
              </div>
              <div class="info-row">
                <span class="label">{{ 'RegistrationDate' | translate }}:</span>
                <span class="value">{{ (user?.CreateDate | time: 'YYYY/MM/DD') }}</span>
              </div>
              <div class="info-row">
                <span class="label">{{ 'LastActivity' | translate }}:</span>
                <span class="value">{{ (user?.ModifyDate | time: 'YYYY/MM/DD') }}</span>
              </div>
            </div>
          </div>
          <div class="info-card quick-orders-access">
            <div class="card-header">
              <mat-icon>shopping_cart</mat-icon>
              <h4>{{ 'QuickOrdersAccess' | translate }}</h4>
            </div>
            <div class="card-content">
              <div class="orders-summary">
                <div class="summary-stats">
                  <div class="stat-item">
                    <div class="stat-number">{{ orders?.length || 0 }}</div>
                    <div class="stat-label">{{ 'TotalOrders' | translate }}</div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-number">{{ getRecentOrdersCount() }}</div>
                    <div class="stat-label">{{ 'RecentOrders' | translate }}</div>
                  </div>
                </div>
                <div class="quick-actions">
                  <button (click)="showDetailedOrders = true; scrollToOrders()"
                          class="action-btn primary">
                    <mat-icon>visibility</mat-icon>
                    <span>{{ 'ViewAllOrders' | translate }}</span>
                  </button>
                  <button (click)="exportOrders()"
                          class="action-btn secondary">
                    <mat-icon>download</mat-icon>
                    <span>{{ 'ExportOrders' | translate }}</span>
                  </button>
                  <button (click)="placeOrderForCustomer()"
                          class="action-btn success">
                    <mat-icon>add_shopping_cart</mat-icon>
                    <span>{{ 'PlaceOrder' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="info-card attributes-summary">
            <div class="card-header">
              <mat-icon>category</mat-icon>
              <h4>{{ 'MemberAttributes' | translate }}</h4>
            </div>
            <div class="card-content">
              @if ((userAttributes ?? []).length > 0) {
                <div class="attributes-preview">
                  @for (attr of userAttributes.slice(0, 3); track attr) {
                    <div class="attribute-tag">
                      <mat-icon>label</mat-icon>
                      <span>{{ attr.Title | translate }}</span>
                    </div>
                  }
                  @if (userAttributes.length > 3) {
                    <div class="more-indicator">
                      +{{ userAttributes.length - 3 }} {{ 'more' | translate }}
                    </div>
                  }
                </div>
              } @else {
                <div class="empty-message">
                  <mat-icon>info</mat-icon>
                  <span>{{ 'NoAttributesAssigned' | translate }}</span>
                </div>
              }
            </div>
          </div>
          <div class="info-card extra-attributes-summary">
            <div class="card-header">
              <mat-icon>extension</mat-icon>
              <h4>{{ 'SpecialFeatures' | translate }}</h4>
            </div>
            <div class="card-content">
              @if ((userExtraAttributes ?? []).length > 0) {
                <div class="attributes-preview">
                  @for (attr of userExtraAttributes.slice(0, 3); track attr) {
                    <div class="attribute-tag premium">
                      <mat-icon>star</mat-icon>
                      <span>{{ attr.Title | translate }}</span>
                    </div>
                  }
                  @if (userExtraAttributes.length > 3) {
                    <div class="more-indicator">
                      +{{ userExtraAttributes.length - 3 }} {{ 'more' | translate }}
                    </div>
                  }
                </div>
              } @else {
                <div class="empty-message">
                  <mat-icon>info</mat-icon>
                  <span>{{ 'NoSpecialFeatures' | translate }}</span>
                </div>
              }
            </div>
          </div>
          <div class="info-card recent-activity">
            <div class="card-header">
              <mat-icon>timeline</mat-icon>
              <h4>{{ 'RecentActivity' | translate }}</h4>
            </div>
            <div class="card-content">
              @if ((orders ?? []).length > 0) {
                <div class="activity-list">
                  @for (order of orders; track order) {
                    <div (click)="showDetailedOrders = true; scrollToOrders()"
                         class="activity-item">
                      <div [ngClass]="getStatusClass(order.Status)"
                           class="activity-icon">
                        <mat-icon>{{ getStatusIcon(order.Status) }}</mat-icon>
                      </div>
                      <div class="activity-details">
                        <div class="activity-title">{{ 'Orderr' | translate }} #{{ order.FactorId }}</div>
                        <div class="activity-time">{{ order.CreateDate | time: 'MM/DD HH:mm' }}</div>
                      </div>
                      <div [ngClass]="getStatusClass(order.Status)"
                           class="activity-status">
                        {{ getStatusLabel(order.Status) }}
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div class="empty-message">
                  <mat-icon>shopping_cart</mat-icon>
                  <span>{{ 'NoRecentOrders' | translate }}</span>
                </div>
              }
            </div>
          </div>
          <div class="info-card user-comments">
            <div class="card-header">
              <mat-icon>rate_review</mat-icon>
              <h4>{{ 'UserComments' | translate }}</h4>
            </div>
            <div class="card-content">
              @if ((userComments ?? []).length > 0) {
                <div class="comments-list">
                  @for (comment of userComments.slice(0, 3); track comment) {
                    <div class="comment-item">
                      <div class="comment-header">
                        <div class="comment-rating">
                          @for (star of [1, 2, 3, 4, 5]; track star) {
                            <mat-icon [class.empty]="star > comment.Rating"
                                      [class.filled]="star <= comment.Rating">
                              {{ star <= comment.Rating ? 'star' : 'star_border' }}
                            </mat-icon>
                          }
                        </div>
                        <div class="comment-date">{{ comment.CreateDate | time: 'YYYY/MM/DD' }}</div>
                      </div>
                      <div class="comment-text">{{ comment.Comment }}</div>
                      @if (comment.OrderId) {
                        <div class="comment-order">
                          <mat-icon>receipt</mat-icon>
                          <span>{{ 'Orderr' | translate }} #{{ comment.OrderId }}</span>
                        </div>
                      }
                    </div>
                  }
                  @if (userComments.length > 3) {
                    <div class="more-comments">
                      <button (click)="showAllComments()"
                              class="view-more-btn">
                        <mat-icon>expand_more</mat-icon>
                        <span>{{ 'ViewAllComments' | translate }} ({{ userComments.length }})</span>
                      </button>
                    </div>
                  }
                </div>
              } @else {
                <div class="empty-message">
                  <mat-icon>rate_review</mat-icon>
                  <span>{{ 'NoCommentsYet' | translate }}</span>
                </div>
              }
            </div>
          </div>
          <div class="info-card sms-messaging">
            <div class="card-header">
              <mat-icon>sms</mat-icon>
              <h4>{{ 'SendSMS' | translate }}</h4>
            </div>
            <div class="card-content">
              <div class="sms-form">
                <div class="form-group">
                  <label>{{ 'MessageTemplate' | translate }}</label>
                  <select (change)="onTemplateChange()"
                          [(ngModel)]="selectedTemplate"
                          class="form-control">
                    <option value="">{{ 'SelectTemplate' | translate }}</option>
                    <option value="welcome">{{ 'WelcomeMessage' | translate }}</option>
                    <option value="promotion">{{ 'PromotionMessage' | translate }}</option>
                    <option value="reminder">{{ 'ReminderMessage' | translate }}</option>
                    <option value="custom">{{ 'CustomMessage' | translate }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>{{ 'MessageText' | translate }}</label>
                  <textarea
                    [(ngModel)]="smsMessage"
                    class="form-control"
                    maxlength="160"
                    placeholder="{{ 'EnterYourMessageHere' | translate }}"
                    rows="4">
                  </textarea>
                  <div class="char-count">{{ smsMessage.length }}/160</div>
                </div>
                <div class="sms-actions">
                  <button (click)="sendSMS()"
                          [disabled]="!smsMessage.trim()"
                          class="action-btn primary">
                    <mat-icon>send</mat-icon>
                    <span>{{ 'SendSMS' | translate }}</span>
                  </button>
                  <button (click)="previewSMS()"
                          [disabled]="!smsMessage.trim()"
                          class="action-btn secondary">
                    <mat-icon>preview</mat-icon>
                    <span>{{ 'Preview' | translate }}</span>
                  </button>
                </div>
                <div class="sms-info">
                  <div class="info-item">
                    <mat-icon>phone</mat-icon>
                    <span>{{ 'Recipient' | translate }}: {{ (user?.MobileNumber | onlinetranslate) }}</span>
                  </div>
                  <div class="info-item">
                    <mat-icon>info</mat-icon>
                    <span>{{ 'SMSWillBeSentToTheCustomersMobileNumber' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detailed-section">
          <div (click)="toggleAttributes()"
               class="section-header">
            <mat-icon [class.rotated]="showDetailedAttributes">expand_more</mat-icon>
            <h3>{{ 'DetailedAttributes' | translate }}</h3>
            <span class="toggle-text">{{ (showDetailedAttributes ? 'Hide' : 'Show') | translate }}</span>
          </div>

          @if (showDetailedAttributes) {
            <div class="detailed-content">
              <div class="attributes-tabs">
                <div (click)="activeTab = 0"
                     [class.active]="activeTab === 0"
                     class="tab-button">
                  <mat-icon>category</mat-icon>
                  <span>{{ 'Attributes' | translate }}</span>
                </div>
                <div (click)="activeTab = 1"
                     [class.active]="activeTab === 1"
                     class="tab-button">
                  <mat-icon>extension</mat-icon>
                  <span>{{ 'ExtraAttributes' | translate }}</span>
                </div>
              </div>
              <div class="attributes-content">
                @if (activeTab === 0) {
                  <div class="attributes-grid">
                    @if ((userAttributes ?? []).length > 0) {
                      @for (userAttribute of userAttributes; track userAttribute) {
                        <div class="attribute-card">
                          <div class="attribute-header">
                            <mat-icon class="attribute-icon">label</mat-icon>
                            <span class="attribute-title">{{ userAttribute.Title | translate }}</span>
                          </div>
                          <div class="attribute-value">
                            {{ (userAttribute.AttributeTitles | onlinetranslate) }}
                          </div>
                        </div>
                      }
                    } @else {
                      <div class="empty-state">
                        <mat-icon class="empty-icon">inbox</mat-icon>
                        <span class="empty-text">{{ 'HasNotAttributes' | translate }}</span>
                      </div>
                    }
                  </div>
                }
                @if (activeTab === 1) {
                  <div class="attributes-grid">
                    @if ((userExtraAttributes ?? []).length > 0) {
                      @for (userExtraAttribute of userExtraAttributes; track userExtraAttribute) {
                        <div class="attribute-card premium">
                          <div class="attribute-header">
                            <mat-icon class="attribute-icon">star</mat-icon>
                            <span class="attribute-title">{{ userExtraAttribute.Title | translate }}</span>
                          </div>
                          <div class="attribute-value">
                            {{ (userExtraAttribute.AttributeTitles | onlinetranslate) }}
                          </div>
                        </div>
                      }
                    } @else {
                      <div class="empty-state">
                        <mat-icon class="empty-icon">inbox</mat-icon>
                        <span class="empty-text">{{ 'HasNotAttributes' | translate }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <div class="detailed-section">
          <div (click)="toggleOrders()"
               class="section-header">
            <mat-icon [class.rotated]="showDetailedOrders">expand_more</mat-icon>
            <h3>{{ 'OrderHistory' | translate }}</h3>
            <span class="toggle-text">{{ (showDetailedOrders ? 'Hide' : 'Show') | translate }}</span>
          </div>

          @if (showDetailedOrders) {
            <div class="cards-grid">
              @for (factor of orders; track factor) {
                <div class="factor-card">
                  <div class="card-content">
                    <div [ngClass]="getStatusClass(factor.Status)"
                         class="card-header">
                      <div class="header-info">
                        <div class="factor-id">
                          <span class="id-label">{{ 'FactorID' | translate }}</span>
                          <span class="id-value">#{{ factor.FactorId }}</span>
                        </div>
                        <div class="factor-date">
                          <mat-icon>schedule</mat-icon>
                          <span>{{ factor.CreateDate | time: 'YYYY/MM/DD HH:mm' }}</span>
                        </div>
                      </div>
                      <div class="status-container">
                        <div class="status-badge">
                          <mat-icon class="status-icon">{{ getStatusIcon(factor.Status) }}</mat-icon>
                          <span>{{ getStatusLabel(factor.Status) }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="card-section customer-section">
                      <div class="customer-details">
                        <div class="info-columns">
                          <div class="customer-column">
                            <div class="customer-info">
                              <div class="info-item">
                                <div class="info-icon">
                                  <mat-icon>person</mat-icon>
                                </div>
                                <div class="info-content">
                                  <span
                                    class="info-value">{{ factor.User?.FirstName }} {{ factor.User?.LastName }}</span>
                                </div>
                              </div>
                              <div class="info-item">
                                <div class="info-icon">
                                  <mat-icon>phone</mat-icon>
                                </div>
                                <div class="info-content">
                                  <span class="info-value">{{ factor.User?.MobileNumber }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="service-column">
                            <div class="service-info">
                              @if (factor.Space) {
                                <div class="info-item table-item">
                                  <div class="info-icon">
                                    <mat-icon>table_restaurant</mat-icon>
                                  </div>
                                  <div class="info-content">
                                    <span class="info-label">{{ 'TableNumber' | translate }}</span>
                                    <span class="info-value table-value">{{ factor.Space.Title }}</span>
                                  </div>
                                </div>
                              }
                              @if (factor.DeliveryMethod) {
                                <div class="info-item">
                                  <div class="info-icon">
                                    @if (factor.DeliveryMethod.Type === 'OUTSIDE_DELIVER') {
                                      <mat-icon>delivery_dining</mat-icon>
                                    } @else {
                                      <mat-icon>restaurant</mat-icon>
                                    }
                                  </div>
                                  <div class="info-content">
                                    <span class="info-value">{{ factor.DeliveryMethod.Title }}</span>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-section order-section">
                      <div class="section-header">
                        <mat-icon>restaurant_menu</mat-icon>
                        <h6>{{ 'Products' | translate }} ({{ factor.FactorOrders?.length || 0 }})</h6>
                      </div>
                      <div class="order-items">
                        @for (order of factor.FactorOrders; track order) {
                          <div class="order-item">
                            <div class="product-card">
                              <div class="product-header">
                                <div class="product-icon">
                                  <mat-icon>restaurant</mat-icon>
                                </div>
                                <div class="product-info">
                                  <div class="product-name">
                                    {{ order.Order?.ServicePrice?.Service?.Title }}
                                    <span class="quantity-badge">x{{ order.Order?.Count }}</span>
                                  </div>
                                  <div
                                    class="product-category">{{ order.Order?.ServicePrice?.Service?.Category?.Title }}
                                  </div>
                                </div>
                                <div class="product-price">
                                  {{ (order.Order?.ServicePrice?.Price * order.Order?.Count) | number }} تومان
                                </div>
                              </div>
                              @if (order.Order?.OrderServicePriceAdditives && order.Order.OrderServicePriceAdditives.length > 0) {
                                <div class="additives-section">
                                  <div class="additives-label">
                                    <mat-icon>add_circle</mat-icon>
                                    <span>{{ 'Additives' | translate }}</span>
                                  </div>
                                  <div class="additives-list">
                                    @for (additive of order.Order.OrderServicePriceAdditives; track additive) {
                                      <div class="additive-item">
                                        <mat-icon>add</mat-icon>
                                        <span>{{ additive.ServicePriceAdditive?.Attribute?.Name }}</span>
                                      </div>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                      <div class="order-total">
                        <div class="total-label">
                          <mat-icon>payments</mat-icon>
                          <span>{{ 'TotalSum' | translate }}</span>
                        </div>
                        <div class="total-amount">
                          {{ factor.PayablePrice | number }} تومان
                        </div>
                      </div>
                    </div>

                    @if (factor.UserAddress) {
                      <div class="card-section delivery-section">
                        <div class="section-header">
                          <mat-icon>location_on</mat-icon>
                          <h6>{{ 'DeliveryAddress' | translate }}</h6>
                        </div>
                        <div class="delivery-details">
                          <div class="delivery-address">{{ factor.UserAddress.Detail }}</div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>

            @if (tableProperties.pageLength > 0) {
              <div class="pagination-container">
                <mat-paginator
                  (page)="pageChanged($event)"
                  [length]="tableProperties.pageLength"
                  [pageIndex]="tableProperties.offset"
                  [pageSizeOptions]="tableProperties.limitOptions"
                  [pageSize]="tableProperties.limit"
                  [showFirstLastButtons]="true">
                </mat-paginator>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
